import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Lightweight modal shell (no external UI library dependency) used
// to host the RbacFormComponent for add/edit across all screens.
@Component({
  selector: 'app-rbac-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rbac-modal.component.html',
  styleUrls: ['./rbac-modal.component.scss']
})
export class RbacModalComponent {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  onBackdropClick(): void {
    this.closed.emit();
  }
}
